export const borderRadius = {
  fullRound: '9999px',
};
